import { Page } from 'layouts/Page';
import { FC } from 'react';
import { Typography } from '@mui/material';
import { Shops } from 'components/Shops';

export const ShopsPage: FC = () => {
	return (
		<Page title="Shops – MPM Service">
			<Shops />
		</Page>
	);
};
